import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import axios from '../../../../library/axios';
import { MySwal } from '../../../../library/swal';
import {
  handleJobQueuedSuccess,
  handleJobRequestError,
} from '../../../../helpers/cpanelJobFeedback';
import {
  DESCRIPTION_MAX_LENGTH,
  hasValidationErrors,
  validateCreateForm,
} from './validation';

const CreateCpanelTenantComp = ({ close, fetch }) => {
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [slug, setSlug] = useState('');
  const [description, setDescription] = useState('');
  const [errors, setErrors] = useState({});

  const handleCreate = (event) => {
    event?.preventDefault();

    const nextErrors = validateCreateForm({ slug, description });
    setErrors(nextErrors);

    if (hasValidationErrors(nextErrors)) {
      return;
    }

    setLoading(true);
    setDisabled(true);

    axios({
      url: '/cpanel/tenants/create',
      method: 'POST',
      data: { slug: slug.trim(), description: description.trim() },
    })
      .then(async (res) => {
        await handleJobQueuedSuccess({
          response: res,
          actionLabel: 'Pembuatan tenant',
          close,
          fetch,
        });
      })
      .catch((err) => {
        handleJobRequestError(err, 'Gagal memulai pembuatan tenant.');
      })
      .finally(() => {
        setLoading(false);
        setDisabled(false);
      });
  };

  return (
    <form noValidate onSubmit={handleCreate}>
      <div className="mb-4">
        <label htmlFor="tenantSlug" className="form-label required">
          Slug
        </label>
        <input
          type="text"
          className={`form-control${errors.slug ? ' is-invalid' : ''}`}
          id="tenantSlug"
          placeholder="contoh: rsud-jakarta"
          value={slug}
          required
          maxLength={255}
          onChange={(e) => {
            setSlug(e.target.value.replace(/[^a-zA-Z0-9_-]/g, ''));
            if (errors.slug) {
              setErrors((prev) => ({ ...prev, slug: undefined }));
            }
          }}
          onBlur={() => {
            const nextErrors = validateCreateForm({ slug, description });
            if (nextErrors.slug) {
              setErrors((prev) => ({ ...prev, slug: nextErrors.slug }));
            }
          }}
        />
        {errors.slug ? <div className="invalid-feedback d-block">{errors.slug}</div> : null}
        <div className="form-text">
          Sistem membuat tenant dengan alamat /hospitals/{slug.trim() || '{slug}'} untuk mengaksesnya.
        </div>
      </div>

      <div className="mb-4">
        <label htmlFor="tenantDescription" className="form-label required">
          Deskripsi
        </label>
        <textarea
          className={`form-control${errors.description ? ' is-invalid' : ''}`}
          id="tenantDescription"
          rows={3}
          value={description}
          required
          minLength={3}
          maxLength={DESCRIPTION_MAX_LENGTH}
          onChange={(e) => {
            setDescription(e.target.value);
            if (errors.description) {
              setErrors((prev) => ({ ...prev, description: undefined }));
            }
          }}
          onBlur={() => {
            const nextErrors = validateCreateForm({ slug, description });
            if (nextErrors.description) {
              setErrors((prev) => ({ ...prev, description: nextErrors.description }));
            }
          }}
        />
        {errors.description ? (
          <div className="invalid-feedback d-block">{errors.description}</div>
        ) : null}
        <div className="form-text">Minimal 3 karakter, maksimal {DESCRIPTION_MAX_LENGTH} karakter.</div>
      </div>

      <div className="alert alert-light border mb-4 py-2 px-3 fs-7 text-muted mb-0">
        Proses berjalan di background. Notifikasi akan muncul saat selesai atau gagal.
      </div>

      <div className="d-flex justify-content-start gap-2">
        <Button variant="light" size="sm" onClick={close}>
          Tutup
        </Button>
        <Button type="submit" variant="primary" size="sm" disabled={disabled}>
          {loading ? 'Memulai job...' : 'Simpan'}
        </Button>
      </div>
    </form>
  );
};

export default CreateCpanelTenantComp;
